import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useContext, useMemo } from 'react';
import axios from 'axios';
import { E_ALERT } from '../../../types/AlertTypes';
import { getErrors } from '../../../utils/utils';
const AlertContext = React.createContext({
    messages: [],
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setAlerts: (e) => { },
});
// const AlertContext = React.createContext<TAlertsContext>(null);
export const useAlerts = () => useContext(AlertContext);
export function AlertProvider({ children }) {
    const [alerts, setAlerts] = useState({ messages: [] });
    const setInner = (err) => {
        var _a, _b;
        // console.log('AlertContext.err', err)
        let msgs = [];
        if (axios.isAxiosError(err)) {
            if (typeof ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === 'string') {
                msgs = [
                    {
                        type: E_ALERT.ERROR,
                        message: err.response.data,
                    },
                ];
            }
            else {
                msgs = getErrors((_b = err.response) === null || _b === void 0 ? void 0 : _b.data);
            }
        }
        if (Array.isArray(err))
            msgs = err;
        if (typeof err === 'object' && Object.keys(err).includes('type'))
            msgs = [err];
        // console.log('AlertContext.messages', msgs)
        if (msgs.length > 0)
            setAlerts({ messages: msgs });
        // console.log("AlertProvider.setAlerts.messages", alerts);
    };
    // console.log('AlertProvider.alerts', messages);
    const alertValue = useMemo(() => ({
        messages: alerts.messages,
        setAlerts: setInner,
    }), [alerts, setInner]);
    return _jsx(AlertContext.Provider, Object.assign({ value: alertValue }, { children: children }));
}
